import React, { useEffect, useMemo } from "react";
import Map from "@arcgis/core/Map";
import SceneView from "@arcgis/core/views/SceneView";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Graphic from "@arcgis/core/Graphic";
import Point from "@arcgis/core/geometry/Point";
import Polygon from "@arcgis/core/geometry/Polygon";
import PolygonSymbol3D from "@arcgis/core/symbols/PolygonSymbol3D";
import ExtrudeSymbol3DLayer from "@arcgis/core/symbols/ExtrudeSymbol3DLayer";
import ObjectSymbol3DLayer from "@arcgis/core/symbols/ObjectSymbol3DLayer";
import FillSymbol3DLayer from "@arcgis/core/symbols/FillSymbol3DLayer";
import axios from "../axios";
import { isValidCoord } from "../utils/coordinateUtils";
import { format } from 'date-fns';
const MapView = ({
  view,
  setView,
  polygons,
  polygonsVisibility,
  mapObjects,
  objectVisibility,
  buildings,
  elevationData,
  apartaments,
}) => {
  /****************************************
   * Build the table-based HTML for owners
   ****************************************/
//   <tr>
//   <td style="padding: 8px; background-color: #f9f9f9; color: #555;">Krijuar me daten</td>
//   <td style="padding: 8px; color: #333;">${format(new Date(), info.createdAt)}</td>
// </tr>
  const buildApartmentOwnerContent = (data) => {
    if (!data) {
      return `
        <div style="padding: 20px; font-family: Arial, sans-serif;">
          <div style="margin-top: 10px; color: #999; font-size: 14px;">
            No details available.
          </div>
        </div>
      `;
    }

    return `
    <div style="font-family: Arial, sans-serif; background-color: #f4f4f4; border-radius: 8px; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);">
      <div style="margin-bottom: 20px;">
        <div class="h6 mb-2 text-end">
          ${data.building_part.detajetEApartamentit && typeof data.building_part.detajetEApartamentit === "string" 
            ? `<a class="text-secondary" href="${process.env.REACT_APP_UPLOADS}/${data.building_part.detajetEApartamentit}" target="_blank" style="color: #007bff; text-decoration: none; font-weight: bold; display: flex; align-items: center;">
                📄 Shiko planin e apartamentit
              </a>` 
            : ""}
        </div>
        
        <h5 style="background-color: #333; color: #ffffff; padding: 10px; margin: 0; border-radius: 5px;">
          📍 Adresa e Njësisë Kadastrale
        </h5>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd; margin-top: 10px; background: #fff; border-radius: 8px; overflow: hidden;">
          <tbody>
            ${data?.cadastral_unit
              ? Object.entries(data.cadastral_unit)
                  .filter(([key]) => key !== "aptId")
                  .map(([key, value]) => `
                    <tr style="border-bottom: 1px solid #ddd;">
                      <td style="background-color: #f9f9f9; color: #555;">
                         ${key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())}
                      </td>
                      <td style="color: #333;">${value || "-"}</td>
                    </tr>`)
                  .join("")
              : "<tr><td colspan='2' style='color: #888;'>❌ Nuk ka detaje të disponueshme</td></tr>"}
          </tbody>
        </table>
      </div>
  
      <div style="margin-bottom: 20px;">
        <h5 style="background-color: #333; color: #ffffff; padding: 10px; margin: 0; border-radius: 5px;">
          🏢 Pjesë e Ndërtesës
        </h5>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd; margin-top: 10px; background: #fff; border-radius: 8px; overflow: hidden;">
          <tbody>
            ${data.building_part
              ? Object.entries(data.building_part)
                  .filter(([key]) => key !== "aptId" && key !== "detajetEApartamentit")
                  .map(([key, value]) => `
                    <tr style="border-bottom: 1px solid #ddd;">
                      <td style="background-color: #f9f9f9; color: #555;">
                         ${key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())}
                      </td>
                      <td style="color: #333;">${value || "-"}</td>
                    </tr>`)
                  .join("")
              : "<tr><td colspan='2' style='color: #888;'>❌ Nuk ka detaje të disponueshme</td></tr>"}
          </tbody>
        </table>
      </div>
  
      <div style="margin-bottom: 20px;">
        <h5 style="background-color: #333; color: #ffffff; padding: 10px; margin: 0; border-radius: 5px;">
          🏡 Pronari / Poseduesi
        </h5>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd; margin-top: 10px; background: #fff; border-radius: 8px; overflow: hidden;">
          <tbody>
            ${data?.owner
              ? Object.entries(data.owner || {})
                  .filter(([key, value]) => value)
                  .map(([key, value]) => `
                    <tr style="border-bottom: 1px solid #ddd;">
                      <td style="background-color: #f9f9f9; color: #555;">
                         ${key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())}
                      </td>
                      <td style="color: #333;">${value || "-"}</td>
                    </tr>`)
                  .join("")
              : "<tr><td colspan='2' style='color: #888;'>❌ Nuk ka detaje të disponueshme</td></tr>"}
          </tbody>
        </table>
      </div>
    </div>
  `;
  
  };

  const getPolygonHierarchyRows = (polygon) => {
    let rows = "";
  
    while (polygon) {
      rows += `
        <tr>
          <td style="padding: 8px; background-color: #f9f9f9; color: #555;">
            ${polygon.listType?.name || "-"}
          </td>
          <td style="padding: 8px; color: #333;">
            ${polygon.name || "-"}
          </td>
          
        </tr>
         <tr>
         ${polygon.listType.listPostalCode?.postal_code_id ? `
          <td style="padding: 8px; background-color: #f9f9f9; color: #555;">
            Kodi Postar
          </td>
          <td style="padding: 8px; color: #333;">
            ${polygon.listType.listPostalCode?.postal_code_id || "-"}
          </td>` : "" }
           </tr>
      `;
  
      polygon = polygon.parent; // Move to the parent polygon
    }
  
    return rows;
  };
  
 const buildObjectPopupContent = (obj, additionalData) => {
  if (!additionalData || !additionalData?.mapObject?.threed_obj_general_info) {
    return `
      <div style="font-family: Arial, sans-serif;">
        <h6 style="background-color: rgb(84, 78, 78); color: #fff; text-align: center; padding: 10px;">
          Basic Information
        </h6>
        <div>ID: ${obj.id}</div>
        <div>Latitude: ${obj.latitude}</div>
        <div>Longitude: ${obj.longitude}</div>
      </div>
    `;
  }

  const info = additionalData?.mapObject?.threed_obj_general_info || {};

  const threedValuesRows = (additionalData?.mapObject?.threed_values || [])
  .filter(val => val.threed_key && (val.name || val.list_id)) 
  .map(val => {
    if (val?.threed_key?.list_type_id != null && val?.list_id != null) {
      const listName = val.threed_key.list_type?.lists?.find(list => list.id === val.list_id)?.name || "-";

      return `
        <tr>
          <td style="padding: 8px; background-color: #f9f9f9; color: #555;">${val.threed_key.name}</td>
          <td style="padding: 8px; color: #333;">${listName}</td>
        </tr>
      `;
    } else {
      return `
        <tr>
          <td style="padding: 8px; background-color: #f9f9f9; color: #555;">${val.threed_key.name}</td>
          <td style="padding: 8px; color: #333;">${val.name || "-"}</td>
        </tr>
      `;
    }
  })
  .join('');


    const polygonRows = getPolygonHierarchyRows(info.polygon);

  return `
    <div style="font-family: Arial, sans-serif;">

<div style="margin-top: 20px;">
  <h6 style="
      background-color: rgb(84,78,78);
      color: #ffffff;
      padding: 10px;
      text-align: center;
      margin: 0;
      border-radius: 5px;">
    Të dhënat e objektit
  </h6>
  <table style="
      width: 100%;
      border-collapse: collapse;
      margin-top: 10px;
      border: 1px solid #ddd;
      font-size: 14px;">
    <tbody>
      <tr>
        <td style="padding: 8px; background-color: #f9f9f9; color: #555;">Object ID</td>
        <td style="padding: 8px; color: #333;">${additionalData?.mapObject?.id || "-"}</td>
      </tr>
      ${threedValuesRows}
    </tbody>
  </table>
</div>



      <div style="margin-top: 20px;">
        <h6 style="
            background-color: rgb(84,78,78);
            color: #ffffff;
            padding: 10px;
            text-align: center;
            margin: 0;
            border-radius: 5px;
           ">
          Të dhënat e lokacionit
        </h6>
           <table style="
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
            border: 1px solid #ddd;
            font-size: 14px;">
          <tbody>
                   ${polygonRows}

          </tbody>
        </table>
      </div>

    </div>
  `;
};

  const buildPolygonPopupContent = (polygon) => {
    if (!polygon) {
      return `<div style="padding: 20px; font-family: Arial, sans-serif;">
                <div style="margin-top: 10px; color: #999; font-size: 14px;">
                  No polygon details available.
                </div>
              </div>`;
    }
  
    const info = polygon.list || {}; 
    const props = polygon.list?.listProperties || {}; 
    return `
    <div style="font-family: Arial, sans-serif; background-color: #f4f4f4; border-radius: 8px; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);">
      <h5 style="background-color: #333; color: #fff; text-align: center; padding: 12px; border-radius: 5px;">
         🔷 Informatat e Poligonit
      </h5>
      <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd; margin-top: 10px; background: #fff; border-radius: 8px; overflow: hidden;">
        <tbody>
          <tr>
            <td style="padding: 12px; background-color: #f9f9f9; color: #555;"> Emri</td>
            <td style="padding: 12px; color: #333;">${polygon.name || "-"}</td>
          </tr>
          <tr>
            <td style="padding: 12px; background-color: #f9f9f9; color: #555;"> Tipi</td>
            <td style="padding: 12px; color: #333;">${info.name || "-"}</td>
          </tr>
          <tr>
            <td style="padding: 12px; background-color: #f9f9f9; color: #555;"> Ngjyra</td>
            <td style="padding: 12px; color: ${props.color || "black"};">
              ${props.color || "-"}
            </td>
          </tr>
          <tr>
            <td style="padding: 12px; background-color: #f9f9f9; color: #555;"> Krijuar më</td>
            <td style="padding: 12px; color: #333;">
              ${polygon.createdAt ? format(new Date(polygon.createdAt), 'dd/MM/yyyy') : "-"}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  `;
  
  };
  
  /****************************************
   * Memoized Layers
   ****************************************/
  /****************************************
 * 1) Polygons Layer
 ****************************************/
const polygonsLayer = useMemo(() => {
  const layer = new GraphicsLayer();
  if (!polygonsVisibility) return layer;

  // Build a lookup map for parent-child depth
  const polygonMap = {};
  (polygons || []).forEach((p) => {
    polygonMap[p.id] = p;
  });

  // Recursively climb up parent_id to find depth
  function getPolygonDepth(poly) {
    let depth = 0;
    let current = poly;
    while (current?.parent_id && polygonMap[current.parent_id] ) {
      depth+=0.5;
      current = polygonMap[current.parent_id];
    }
    return depth;
  }

  // Sort polygons by ascending depth => parents first, children after
  const sortedPolygons = [...(polygons || [])].sort((a, b) => {
    return getPolygonDepth(a) - getPolygonDepth(b);
  });

  sortedPolygons.forEach((poly,index) => {

    const rings = poly.polygon_points.map((pt) => [
      pt.longitude,
      pt.latitude,
      elevationData ? pt.altitude : 0
    ]);

    // Create geometry
    const polygon = new Polygon({
      rings: [rings],
      spatialReference: { wkid: 4326 }
    });
    const depth = getPolygonDepth(poly);
    // Pick your color
    const polygonHex = poly?.list?.listProperties?.color || "#f5602a";

    // Build 3D symbol
    const symbol = new PolygonSymbol3D({
      symbolLayers: [
        // Slight fill layer (can be made transparent if needed)
        new FillSymbol3DLayer({
          material: {
            // Example: partial transparency for all polygons, if desired:
            // color: hexToRgba(polygonHex, 0.8)
          },
          outline: {
            color: "rgba(253, 105, 105, 0.5)",
            size: 1
          }
        }),
        // Extrude a bit so polygons have thickness
        new ExtrudeSymbol3DLayer({
          material: { color: polygonHex },
          size:depth == 0 ? 0.1 : depth * 0.05 // or 0.1, as you prefer
        })
      ],
      // The key to stacking visually above the parent
      // elevationInfo: {
      //   mode: "relative-to-ground",
      //   offset: offsetValue
      // }
    });

    // Create and add graphic
    const graphic = new Graphic({
      geometry: polygon,
      symbol,
      attributes: {
        name: poly.name,
        objectDetail: "Polygon"
      },
      popupTemplate: {
        title: `Polygon: ${poly.name}`,
        content: () => buildPolygonPopupContent(poly),
      },
    });

    layer.add(graphic);
  });

  return layer;
}, [polygons, polygonsVisibility, elevationData]);


  
  

  

{console.log("mapObjects",mapObjects)}
  // 2) 3D Objects Layer
  const objectsLayer = useMemo(() => {
    const layer = new GraphicsLayer();
    if (!objectVisibility) return layer;

    (mapObjects || []).forEach((obj) => {
      const objectPoint = new Point({
        longitude: obj.longitude,
        latitude: obj.latitude,
        z:  obj?.threed_obj_general_info?.altitude,
        // z:  obj.altitude,
        spatialReference: { wkid: 4326 },
      });

      const objectSymbol = {
        type: "point-3d",
        symbolLayers: [
          new ObjectSymbol3DLayer({
            resource: {
              href: process.env.REACT_APP_UPLOADS + "/" + obj.object_href,
            },
            height: obj?.threed_obj_general_info?.height || obj?.height,
            tilt: obj.tilt,
            heading: obj.heading,
          }),
        ],
      };

      const objectGraphic = new Graphic({
        geometry: objectPoint,
        symbol: objectSymbol,
        attributes: { ...obj, objectDetail: "Object3D" },
        popupTemplate: {
          title: `${obj.name}`,
          content: async () => {
            let additionalData = null;
            try {
              const response = await axios.get(`/map-objects/${obj?.id}`);
              additionalData = response?.data?.data;
            } catch (error) {
              console.error("Error fetching additional data:", error);
            }
            return buildObjectPopupContent(obj, additionalData);
          },
        },
      });

      layer.add(objectGraphic);
    });

    return layer;
  }, [mapObjects, objectVisibility, elevationData]);

  
// 3) Apartments Layer
const apartmentsLayer = useMemo(() => {
  // Give it a title so we can easily look it up:
  const layer = new GraphicsLayer({ title: "Apartments" });

  (apartaments || []).forEach((apt) => {
    // (Same checks: if invalid coords, skip, etc.)

    const apartmentPolygon = new Polygon({
      rings: apt.coords.map((coord) => [
        coord[0],
        coord[1],
        apt.floorAltitude,
      ]),
      spatialReference: { wkid: 4326 },
    });

    const apartmentSymbol = new PolygonSymbol3D({
      symbolLayers: [
        new ExtrudeSymbol3DLayer({
          material: { color: apt.color || "orange" },
          size: Math.max(apt.floorHeight || 2, 2),
        }),
      ],
    });

    const apartmentGraphic = new Graphic({
        geometry: apartmentPolygon,
        symbol: apartmentSymbol,
        attributes: {
          // Store a unique apartmentId so we know which apt to fetch
          apartmentId: apt.apartmentId,
          floor: apt.floor,
          name:apt.name,
          area: `${apt.coords.length * 50} m²`,
          aptColor: apt.color,
          objectDetail: "ApartmentDetail",
        },
        // ----- POPUP TEMPLATE: MAKE IT ASYNC -----
        popupTemplate: {
          title: `Apartment: ${apt.name}`,
          content: async () => {
            let details = null;
            try {
              // 1) Fetch apt details from your API
              const response = await axios.get(`/apartment-info/apartment/${apt.apartmentId}`);
              details = response?.data?.data;
            } catch (error) {
              console.error("Failed to fetch apartment info:", error);
            }
      
            // 2) If no data, show something simple
            if (!details) {
              return `<p style="color: red;">No details available for this apartment.</p>`;
            }
      
            // 3) Build the fancy HTML from your existing function
            //    (Assuming you have buildApartmentOwnerContent imported or in the same file)
            return buildApartmentOwnerContent(details);
          },
        },
      });
      

    layer.add(apartmentGraphic);
  });

  return layer;
}, [apartaments, elevationData]);


  // 4) Buildings Layer (Extruded Floors)
  const buildingGraphicsLayer = useMemo(() => {
    const layer = new GraphicsLayer();
  
    // A helper function to attach the click event listener for apartment items.
    // (This listener is attached once per popup content generation.)
    function attachApartmentClickListener() {
      document.addEventListener("click", async (ev) => {
        if (!ev.target.classList.contains("apartment-item")) return;
        ev.preventDefault();
        ev.stopPropagation();
  
        const aptDataTest = ev.target.querySelector("span");
        const decodedData = decodeURIComponent(aptDataTest?.classList[0] || "{}");
        const aptData = JSON.parse(decodedData);
  
        if (!aptData?.apartmentId) {
          console.error("Apartment ID is missing!");
          return;
        }
        if (ev.target.dataset.fetching === "true") {
          console.log(`Already fetching data for Apartment ID: ${aptData.apartmentId}`);
          return;
        }
        ev.target.dataset.fetching = "true";
        try {
          const { data } = await axios.get(`apartment-info/apartment/${aptData.apartmentId}`);
          const popupContent = buildApartmentOwnerContent(data?.data);
          if (view) {
            view.popup.open({
              title: aptData.name ? `Apartment: ${aptData.name}` : "Apartment Details",
              content: popupContent,
              location: {
                longitude: aptData?.coords?.[0]?.[0] || 0,
                latitude: aptData?.coords?.[0]?.[1] || 0,
              },
            });
          }
          const apartmentsLayer = view.map.findLayerByTitle("Apartments");
          if (apartmentsLayer) {
            const match = apartmentsLayer.graphics.find(
              (g) => g.attributes.apartmentId === aptData.apartmentId
            );
            if (match) {
              view.whenLayerView(apartmentsLayer).then((layerView) => {
                if (window._highlightHandle) window._highlightHandle.remove();
                window._highlightHandle = layerView.highlight(match);
              });
            }
          }
        } catch (err) {
          console.error("Error fetching apartment data:", err);
        } finally {
          ev.target.dataset.fetching = "false";
        }
      });
    }
  
    // Process each building
    buildings.forEach((building) => {
      const {
        buildingName,
        convertedObjects,
        floorsHeight,
        absoluteQuotas,
        heightFloors,
        colors,
        floorDetails,
      } = building;
      const sliceHeight = 0.1;
  
      // For multi‑floor buildings without elevation data, maintain a running altitude.
      let currentAltitude = elevationData ? undefined : 0;
  
      // Loop through every floor (this single loop covers both one‑floor and multi‑floor cases)
      for (let i = 0; i < floorsHeight; i++) {
        const detail = floorDetails[i];
        const color = colors[i % colors.length];
        const floorAltitude = elevationData ? absoluteQuotas[i] : i * 3;
        const floorHeight = (heightFloors[i] || 3) - sliceHeight;

        const floorPolygon = new Polygon({
          rings: convertedObjects.map((ring) => [
            ring[0],
            ring[1],
            floorAltitude,
          ]),
          spatialReference: { wkid: 4326 },
        });

        const floorSymbol = new PolygonSymbol3D({
          symbolLayers: [
            new ExtrudeSymbol3DLayer({
              material: {
                color: floorsHeight === 1 ? color : "rgba(196, 183, 190, 0.2)",
              },
              size: floorHeight,
            }),
          ],
        });
        // Create the floor graphic with its popup template.
        const floorGraphic = new Graphic({
          geometry: floorPolygon,
          symbol: floorSymbol,
          attributes: {
            buildingName,
            floorName: detail.name,
            floorNumber: detail.floor,
            floor: i + 1,
            objectDetail: "BuildingDetail",
            totalFloors: floorsHeight,
          },
        //   popupTemplate: {
        //     title: (feature) => {
        //       const { floorName, floorNumber } = feature.graphic.attributes;
        //       const floorIds = floorDetails.map((d) => d.id);
        //       const apartmentsOnFloor = apartaments.filter(
        //         (apt) =>
        //           floorIds.includes(apt.id) &&
        //           apt.floorName === `${floorName} ${floorNumber}` &&
        //           apt.coords &&
        //           apt.coords.length > 0 &&
        //           apt.coords.every(isValidCoord)
        //       );
        //       console.log("aptNames", apartmentsOnFloor);
        //       return `${floorName} ${floorNumber}`;
        //     },
        //     content: (feature) => {
        //       const floorNumber = feature.graphic.attributes.floorNumber;
        //       const floorBuildingName = feature.graphic.attributes.buildingName;
        //       const floorName = feature.graphic.attributes.floorName;
        //       const floorIds = floorDetails.map((d) => d.id);
        //       const apartmentsOnFloor = apartaments.filter((apt) => {
        //         if (!floorIds.includes(apt.id)) return false;
        //         if (apt.floorName !== `${floorName} ${floorNumber}`) return false;
        //         if (!apt.coords || apt.coords.length === 0) return false;
        //         if (!apt.coords.every(isValidCoord)) return false;
        //         return true;
        //       });
        //       let apartmentList = "<div>";
        //       apartmentsOnFloor.forEach((apt, index) => {
        //         apartmentList += `
        //           <a href="#">
        //             <div
        //               class="apartment-item"
        //               style="cursor: pointer; color: blue; text-decoration: underline; margin: 5px 0;"
        //             >
        //               ${index + 1}. ${apt.name} - ${apt.area || "-"} m²
        //               <span class='${encodeURIComponent(JSON.stringify(apt))}'></span>
        //             </div>
        //           </a>
        //         `;
        //       });
        //       apartmentList += "</div>";
        //       // Attach the click listener for apartment items.
        //       attachApartmentClickListener();
        //       return `
        //         <b>Building:</b> ${floorBuildingName} <br />
        //         ${
        //           apartmentsOnFloor.length > 0
        //             ? `<b>Apartments:</b> ${apartmentList}`
        //             : `<div style="margin-top: 10px; color: #999; font-size: 14px;">
        //                  No apartments available.
        //                </div>`
        //         }
        //       `;
        //     },
        //   },
        });
  
        layer.add(floorGraphic);
  
        // For multi‑floor buildings, update the running altitude and add a slice graphic if needed.
        if (floorsHeight > 1) {
          if (!elevationData) {
            currentAltitude += floorHeight;
          }
          if (i < floorsHeight - 1) {
            const sliceAltitude = (elevationData ? absoluteQuotas[i] : currentAltitude) + floorHeight;
            const slicePolygon = new Polygon({
              rings: convertedObjects.map((ring) => [
                ring[0],
                ring[1],
                elevationData ? sliceAltitude : currentAltitude,
              ]),
              spatialReference: { wkid: 4326 },
            });
            const sliceSymbol = new PolygonSymbol3D({
              symbolLayers: [
                new ExtrudeSymbol3DLayer({
                  material: { color: "#FFFFFF" },
                  size: sliceHeight,
                }),
              ],
            });
            const sliceGraphic = new Graphic({
              geometry: slicePolygon,
              symbol: sliceSymbol,
              attributes: {
                buildingName,
                slice: i + 1,
              },
            });
            // layer.add(sliceGraphic);
        }
        layer.add(floorGraphic);
        }
      } // end for-each floor
    }); // end for-each building
  
    return layer;
  }, [buildings, apartaments, elevationData]);
  

  /****************************************
   * useEffect: Initialize / Update Map
   ****************************************/
  useEffect(() => {
    if (!view) {
      // Create the ArcGIS map & SceneView once
      const map = new Map({
        basemap: "topo-vector",
        ground: elevationData ? "world-elevation" : null,
      });

      const sceneView = new SceneView({
        container: "viewDiv",
        qualityProfile: "high",
        map: map,
        camera: {
          position: [21.146644, 42.644623, 1100],
          tilt: 60,
        },
        environment: {
          lighting: {
            directShadowsEnabled: true,
            ambientOcclusionEnabled: true,
            date: new Date("2024-07-20T16:00:00"),
          },
        },
      });

      setView(sceneView);
      return;
    }

    // If we already have a view, re-add memoized layers
    view.map.removeAll();

    view.map.add(polygonsLayer);
    view.map.add(objectsLayer);
    view.map.add(apartmentsLayer);
    view.map.add(buildingGraphicsLayer);
  }, [
    view,
    setView,
    polygonsLayer,
    objectsLayer,
    apartmentsLayer,
    buildingGraphicsLayer,
    elevationData,
  ]);

  return <div id="viewDiv" style={{ height: "100vh", width: "100%" }}></div>;
};

export default MapView;
